import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { DATE_PICKER_FORMAT, oneTime, SERVER_DATE_FORMAT, SERVER_TIMEZONE, } from '../constants';
import { RemoteStatus } from '../Remote';
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);
dayjs.extend(isSameOrAfter);
var NdtAsStandard = function (deliveryDate, standardSpeed) {
    if (!deliveryDate) {
        return 'Next Day';
    }
    if (!dayjs(deliveryDate, DATE_PICKER_FORMAT, true).isValid()) {
        return 'Next Day';
    }
    var standardDate = dayjs.tz(standardSpeed.deliveryDate, SERVER_DATE_FORMAT, SERVER_TIMEZONE);
    var date = dayjs.tz(deliveryDate, DATE_PICKER_FORMAT, SERVER_TIMEZONE);
    if (date.isSameOrAfter(standardDate, 'day')) {
        return 'Standard';
    }
    return 'Next Day';
};
var selectTransferSpeed = function (_a, ndtAsStandard) {
    var deliveryDate = _a.deliveryDate, _b = _a.frequency, frequency = _b === void 0 ? oneTime : _b, transferSpeeds = _a.transferSpeeds, transferType = _a.transferType;
    if (ndtAsStandard === void 0) { ndtAsStandard = true; }
    if (transferType !== 'EXTERNAL' ||
        frequency !== oneTime ||
        transferSpeeds.status !== RemoteStatus.Loaded) {
        return 'Standard';
    }
    var isNdtEligible = transferSpeeds.data.some(function (_a) {
        var transferSpeed = _a.transferSpeed;
        return transferSpeed === 'Next Day';
    });
    if (!isNdtEligible)
        return 'Standard';
    if (ndtAsStandard) {
        var standardSpeed = transferSpeeds.data.find(function (_a) {
            var transferSpeed = _a.transferSpeed, transferfrequency = _a.transferfrequency;
            return transferfrequency === 'OneTime Transfer' &&
                transferSpeed === 'Standard';
        });
        return NdtAsStandard(deliveryDate, standardSpeed);
    }
    return 'Next Day';
};
export default selectTransferSpeed;
//# sourceMappingURL=selectTransferSpeed.js.map